import { render } from "./ModuloForm.vue?vue&type=template&id=7bc1d595"
import script from "./ModuloForm.vue?vue&type=script&lang=js"
export * from "./ModuloForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__